<template>
  <footer class="bg-[#1a1a1a] text-gray-400 text-sm text-center py-6">
      © {{ new Date().getFullYear() }} GetLance - Todos os direitos reservados.
    </footer>
</template>

<script setup>

</script>

<style scoped></style>